import { useEffect, useState } from 'react';
import BlogCard from '../components/blog/BlogCard';
import { getAllBlogPosts } from '../lib/markdown';
import type { BlogPost } from '../types/blog';

export default function Blog() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  const [allTags, setAllTags] = useState<string[]>([]);

  useEffect(() => {
    getAllBlogPosts().then(data => {
      setPosts(data);
      // Extract all unique tags
      const tags = Array.from(new Set(data.flatMap(post => post.tags)));
      setAllTags(tags);
      setLoading(false);
    });
  }, []);

  const filteredPosts = selectedTag
    ? posts.filter(post => post.tags.includes(selectedTag))
    : posts;

  if (loading) {
    return (
      <div className="container-custom py-20">
        <h1 className="text-5xl md:text-6xl font-heading font-bold mb-12 text-center">
          博客
        </h1>
        <div className="text-center text-xl">加载中...</div>
      </div>
    );
  }

  return (
    <div className="container-custom py-12">
      <h1 className="text-5xl md:text-6xl font-heading font-bold mb-8 text-center">
        博客
      </h1>
      <p className="text-xl text-gray-600 text-center mb-12 max-w-2xl mx-auto">
        探索技术文章、开发心得和创意思考
      </p>

      {/* Tag filter */}
      {allTags.length > 0 && (
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          <button
            onClick={() => setSelectedTag(null)}
            className={`px-4 py-2 border-2 border-black rounded-full transition-all ${
              selectedTag === null
                ? 'bg-cta text-white'
                : 'bg-white hover:bg-gray-100'
            }`}
          >
            全部
          </button>
          {allTags.map((tag) => (
            <button
              key={tag}
              onClick={() => setSelectedTag(tag)}
              className={`px-4 py-2 border-2 border-black rounded-full transition-all ${
                selectedTag === tag
                  ? 'bg-cta text-white'
                  : 'bg-white hover:bg-gray-100'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
      )}

      {filteredPosts.length === 0 ? (
        <div className="text-center text-xl text-gray-600 py-12">
          {selectedTag ? `没有找到标签为 "${selectedTag}" 的文章` : '暂无博客文章'}
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredPosts.map((post) => (
            <BlogCard key={post.slug} post={post} />
          ))}
        </div>
      )}
    </div>
  );
}
